import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RequestStatus } from '../../../config/store';
import useCurrentUser from '../../../hooks/useCurrentUser';
import { RootState } from '../../../store/rootStore';
import logsSlice, { getLogs } from '../store/logs.store';

const LOAD_ENTRIES_TILL_LOADED = 20;

const useLogs = () => {
  const dispatch = useDispatch<any>();
  const { groupsWithAdminRight } = useCurrentUser();
  const { filter } = useSelector((state: RootState) => state.logs);

  const [currentGroupId, setCurrentGroup] = React.useState<string | null>(
    groupsWithAdminRight.length ? groupsWithAdminRight[0].id : null
  );

  const groupOptions = React.useMemo(() => {
    return groupsWithAdminRight.map((gr) => ({ value: gr.id, label: gr.name }));
  }, [groupsWithAdminRight]);
  React.useEffect(() => {
    if (groupsWithAdminRight.length) {
      setCurrentGroup((gr) => gr || groupsWithAdminRight[0].id);
    }
  }, [groupsWithAdminRight]);
  const { logs } = useSelector((state: RootState) => state.logs);

  const fetchLogs = React.useCallback(
    (groupId = currentGroupId) => {
      if (!!dispatch && !!groupId && logs.request.get.status !== 'PENDING') {
        dispatch(
          getLogs({
            groupId: groupId,
          })
        );
      }
    },
    [dispatch, currentGroupId, logs.request.get.status]
  );
  const handleGroupChange = React.useCallback(
    (groupId: string) => {
      dispatch(logsSlice.actions.reset());
      setCurrentGroup(groupId);
      fetchLogs(groupId);
    },
    [dispatch, fetchLogs]
  );
  React.useEffect(() => {
    if (!!currentGroupId && !!dispatch) {
      dispatch(
        getLogs({
          groupId: currentGroupId,
        })
      );
    }
  }, [currentGroupId, dispatch, filter]);
  return {
    logs: logs.data?.results || [],
    isLoading: logs.request.get.status === RequestStatus.Pending,
    needRefresh: logs.request.get.status === RequestStatus.Failure,
    fetchLogs,
    groupOptions,
    selectedGroup: currentGroupId,
    onGroupChange: handleGroupChange,
  };
};

export default useLogs;
